
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import HcAddress from "./HcAddress.vue";
import IBlock3Entrepreneur from "@/module/main/model/applicationForm/IBlock3Entrepreneur";
import BusinessArea from "@/module/main/dto/customer/BusinessAreaEnum";
import { EnumUtil } from "@/app";

@Component({
    components: {
        HcAddress
    }
})
export default class Block3Entrepreneur extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock3Entrepreneur;

    protected pageName: string = "block3-entrepreneur";

    private get businessAreaData(): object[] {
        return EnumUtil.createSelectDataFromEnum(BusinessArea, "BusinessArea", true);
    }
}
